import Radio from './Radio'

Radio.install = function install (Vue) {
  Vue.component(Radio.name, Radio)
}

export default Radio



// WEBPACK FOOTER //
// ./src/components/reusable/radio/index.js